import { apiSendAccountDetails } from '../../../../../../common/api/profile'
import { schoolsSearch } from '../../../../../../common/api/school'

const finishAsParent = () => ({
  requestPrefix: 'FSU_TEACHER:FINISH_AS_PARENT',
  request: () => apiSendAccountDetails({ signup_account_type_decision: 'user' })
})

const searchSchool = value => ({
  requestPrefix: 'FSU_TEACHER:SEARCH_SCHOOL',
  params: { value },
  request: () =>
    schoolsSearch({
      search_term: value,
      all_schools: true,
      limit: 10,
      include_location: true
    })
})

const setSchool = data => ({
  type: 'FSU_TEACHER:SET_SCHOOL',
  data
})

const showNewSchool = () => ({
  type: 'FSU_TEACHER:SHOW_NEW_SCHOOL'
})

const clearState = () => ({
  type: 'FSU_TEACHER:CLEAR_STATE'
})

export { searchSchool, setSchool, showNewSchool, finishAsParent, clearState }
